<template>
<div>
    <el-tabs @tab-click="handleClick" v-model="activeName">
       <!-- <el-tab-pane label="邮件发送" name="sendMail">
            <el-form :model="detail" ref="form" label-width="150px">
                <el-form-item label="标题:" prop="subject">
                    <el-input v-model="detail.subject"></el-input>
                </el-form-item>
                <el-form-item label="收件人:">
                    <el-upload ref="upload" action="" :auto-upload="false" :on-change="onFileChange">
                        <el-button type="info"><i class="el-icon-plus"></i>批量导入收件人</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="图片：" prop="imageUrl">
                    <upload v-model="detail.imageUrl" :data="{language: 1, platform: 1}"></upload>
                </el-form-item>
                <el-form-item prop="context" label="内容">
                    <editor v-model="detail.context" class="editor"></editor>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="hanldSave()">发送</el-button>
                </el-form-item>
            </el-form>
        </el-tab-pane>-->
        <el-tab-pane label="短信邮件服务商通道管理" name="provider" v-if="rightsContains('AUTHORITY_SETTING')">
            <el-card>
                <div slot="header"><span>邮件服务商</span></div>
                <div>
                    <el-radio-group v-model="emailProviderType" style="margin-right: 20px;">
                        <el-radio label="ALIYUN_MAIL" border>阿里云</el-radio>
                        <el-radio label="KE_WAIL_MAIL" border>摩杜拉</el-radio>
                        <el-radio label="RANDOM_MAIL" border>随机</el-radio>
                    </el-radio-group>
                    <el-button type="primary" @click="saveEmailServiceProvider()">保存</el-button>
                </div>
            </el-card>
            <el-card>
                <div slot="header"><span>短信服务商</span></div>
                <div>
                    <el-radio-group v-model="smsProviderType" style="margin-right: 20px;">
                        <el-radio label="SMS_YUNPIAN" border>云片</el-radio>
                        <el-radio label="SMS_KEWAIL" border>摩杜拉</el-radio>
                        <el-radio label="SMS_RANDOM" border>随机</el-radio>
                    </el-radio-group>
                    <el-button type="primary" @click="saveSmsServiceProvider()">保存</el-button>
                </div>
                <div style="color: red">云片只发中国区短信，即国际码为：86 的用户</div>
            </el-card>
        </el-tab-pane>

        <el-dialog title="定时发送" :visible.sync="showOnTime" @close="showOnTime = false" width="15%" :center="true">
            <el-form style="text-align: center;width: 100%">
                 <el-form-item>
                     <el-date-picker v-model="detail.sendTime" type="datetime" placeholder="选择发送时间" value-format="timestamp"></el-date-picker>
                 </el-form-item>
                 <el-form-item>
                     <el-button type="primary" @click="sendOnTime()">发送</el-button>
                     <el-button type="info" @click="showOnTime = false">取消</el-button>
                 </el-form-item>
             </el-form>
        </el-dialog>
    </el-tabs>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import './store';
import editor from 'components/editor';
import upload from 'components/upload';
import { RIGHTS_TYPE } from "../../common/constant";
import api from './api';
import XLSX from "xlsx";
export default {
    name:'index',
    data() {
       return {
           detail: {
               subject: '',
               imageUrl: '',
               context: '',
               emailStr: '',
               sendTime: '',
           },
           activeName:'sendMail',
           emailProviderType:'',
           smsProviderType:'',
           showOnTime: false,
       }
    },
    computed: {
        ...mapState(["userInfo", "userRights"])
    },
    methods: {
        hanldSave() {
            this.$confirm('确认发送?', '提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() =>{
                api.create(this.detail).then(() => {
                    this.detail = {};
                    this.$message.success('发送成功');
                })
            }).catch(() =>{
                this.$message.info('取消发送');
            })
        },
        sendOnTime(){
            if (this.detail.sendTime){
                api.sendEmailOnTime(this.detail).then(() =>{this.$message.success('发送成功')});
            }else {
                this.$message.error('请选择定时发送时间');
            }
        },
        handleClick(tab) {
            if (tab.name === 'provider') {
                api.queryMailProvider().then(response => {
                    this.emailProviderType = response.data
                });
                api.querySmsProvider().then(response => {
                    this.smsProviderType = response.data
                });
            }
        },
        rightsContains(r) {
            let rights = this.userRights.split(",") || [];
            return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
        },
        saveEmailServiceProvider() {
            api.saveMailProvider({mailProvider: this.emailProviderType}).then(() => {
                this.$message.success('保存成功')
            });
        },
        saveSmsServiceProvider() {
            api.saveSmsProvider({smsProvider: this.smsProviderType}).then(() => {
                this.$message.success('保存成功')
            });
        },
        onFileChange(file) {
            if (!file)return;
            const { raw: originFile } = file;
            const { name, size } = originFile;
            const suffix = name.split('.').pop();
            if (suffix !== 'xlsx') {
                return this.$message.error('只接受xlsx类型的文件');
            }
            const reader = new FileReader();
            let that = this;
            reader.onload = function (e) {
                let binary = '';
                const bytes = new Uint8Array(e.target.result);
                const length = bytes.byteLength;
                for (let i = 0; i < length; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                /* read workbook */
                const wb = XLSX.read(binary, {
                    type: 'binary'
                });
                /* grab first sheet */
                const wsName = wb.SheetNames[0];
                const ws = wb.Sheets[wsName];
                /* generate HTML */
                const json = XLSX.utils.sheet_to_json(ws);
                json.forEach(item => {
                    that.detail.emailStr = that.detail.emailStr + item.email + ",";
                })
            };
            reader.readAsArrayBuffer(originFile);
        }
    },
    components: {
      editor,
      upload
    }
}
</script>
